/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { findManyInterventionsAlerts } from '../../lib/rest/interventionAPIClient'
import { useQuery } from '@tanstack/react-query'
import { Alert, Stack } from '@mantine/core'

export type InterventionListAlertsProps = {
  estateId?: number;
  leaseId?: number;
}

function InterventionListAlerts (props: InterventionListAlertsProps) {
  const { estateId, leaseId } = props
  const intl = useIntl()

  const { data } = useQuery({
    enabled: true,
    queryKey: ['interventionsAlerts', estateId, leaseId],
    queryFn: () => findManyInterventionsAlerts({ estateId, leaseId })
  })

  const alerts = useMemo(() => {
    const rows: { color?: string, message: string }[] = []
    if (!data) {
      return rows
    }
    if (data?.expired) {
      rows.push({
        color: 'yellow',
        message: intl.formatMessage({
          id: 'expired_interventions',
          defaultMessage: 'Des interventions ont été planifiées depuis plus d\'un mois et n\'ont pas été mises à jour (aucune date de fin), utilisez le filtre "Expiré" pour les lister.'
        })
      })
    }
    if (data?.missingTransaction) {
      rows.push({
        color: 'red',
        message: intl.formatMessage({
          id: 'missing_interventions_transactions',
          defaultMessage: 'Des interventions n\'ont pas été facturées, utilisez le filtre "Transaction manquante" pour les lister. Si elles ont déjà été saisies, veuillez lier ces interventions dans le champ "Intervention" des dépenses.'
        })
      })
    }
    return rows
  }, [data, intl])

  return <Stack>
    {alerts.map((alert) => (
      <Alert
        key={alert.message}
        color={alert.color || 'warning'}
        icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
      >
        {alert.message}
      </Alert>
    ))
    }
  </Stack>
}

export default InterventionListAlerts
